import { LockOpen } from '@mui/icons-material'
import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const LockIconCustom = styled(LockOpen)<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor, disabled }) =>
    disabled ? 'pointer' : cursor || 'pointer'};
  color: ${({ colorIcon }) => colorIcon || COLORS.black};
  opacity: ${({ disabled }) => (disabled ? '0.15' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};

  transform: scaleX(-1);
`
